module.exports = __webpack_public_path__ + "img/backgroundQr.1a3543f4.webp";